import {allRequest, postRequest, REQUEST_METHOD_POST} from "../../../../../middlewares/api/actions";
import {getDataflowColumnPreviewUrl, getPaginatedCodelistUrl} from "../../../../../constants/urls";
import {getFilterObjFromStr, getServerQueryObj} from "../../../../../utils/filter";
import {convertFilterStrWithSimpleFilterForTimePeriod} from "../../../../../components/tree-filter/utils";

export const DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SHOW = "DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SHOW";
export const DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_HIDE = "DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_HIDE";
export const DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SUBMIT = "DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SUBMIT";
export const DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_RESET = "DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_RESET";
export const DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ = "DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ";
export const DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET = "DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET";
export const DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_READ = "DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_READ";
export const DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_RESET = "DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_RESET";

export const showDataflowBuilderWizardLayoutAnnotationsForm = () => ({
  type: DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SHOW
});

export const hideDataflowBuilderWizardLayoutAnnotationsForm = () => ({
  type: DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_HIDE
});

export const submitDataflowBuilderWizardLayoutAnnotationsForm = annotations => ({
  type: DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_SUBMIT,
  annotations
});

export const resetDataflowBuilderWizardLayoutAnnotationsForm = () => ({
  type: DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_FORM_RESET
});

export const readDataflowBuilderWizardLayoutAnnotationsItemsPage = ({
                                                                      codelistTriplet,
                                                                      language,
                                                                      pageNum,
                                                                      pageSize,
                                                                      searchText,
                                                                      filters,
                                                                      sortCol,
                                                                      sortByDesc
                                                                    },
                                                                    cubeId,
                                                                    colNames,
                                                                    colName,
                                                                    filterStr,
                                                                    selectedCodes
) => ({
  ...allRequest(
    DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_READ,
    [REQUEST_METHOD_POST, REQUEST_METHOD_POST],
    [getPaginatedCodelistUrl(), getDataflowColumnPreviewUrl(colName, 1, -1)],
    [{
      Id: codelistTriplet.id,
      AgencyId: codelistTriplet.agencyID,
      Version: codelistTriplet.version,
      Lang: language,
      PageNum: pageNum,
      PageSize: pageSize,
      AllSearch: searchText,
      CodeSearch: filters.id ? filters.id : undefined,
      NameSearch: filters.name ? filters.name : undefined,
      ParentSearch: filters.parent ? filters.parent : undefined,
      SortColumn: sortCol ? sortCol : undefined,
      SortDesc: sortByDesc ? sortByDesc : undefined,
      rebuildDb: false
    },
      {
        idCube: cubeId,
        dataflowColumns: colNames,
        filter: getServerQueryObj(undefined, getFilterObjFromStr(convertFilterStrWithSimpleFilterForTimePeriod(filterStr))).Filter
      }
    ]
  ),
  colName,
  selectedCodes
});

export const resetDataflowBuilderWizardLayoutAnnotationsItemsPage = () => ({
  type: DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_ITEMS_PAGE_RESET
});

export const fetchDataflowBuilderWizardLayoutAnnotationsValues =
  (
    cubeId,
    colNames,
    colName,
    filterStr
  ) => ({
    ...postRequest(
      DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_READ,
      getDataflowColumnPreviewUrl(colName, 1, -1),
      {
        idCube: cubeId,
        dataflowColumns: colNames,
        filter: getServerQueryObj(undefined, getFilterObjFromStr(convertFilterStrWithSimpleFilterForTimePeriod(filterStr))).Filter
      }
    ),
    colName
  });

export const resetDataflowBuilderWizardLayoutAnnotationsValues = () => ({
  type: DATAFLOW_BUILDER_WIZARD_LAYOUT_ANNOTATIONS_VALUES_RESET
});


// WEBPACK FOOTER //
// ./src/scenes/data-manager/dataflow-builder/wizard/layout-annotations/actions.js